const paymentTypes = [
  'COMPENSATIONBYAGREEMENT',
  'GROUPPAYMENT',
  'PERPERSON',
  'HOURLYRATE',
  'NOCOMPENSATION',
];

export default paymentTypes;
